<template>
	<div class="grid">
		<div class="col-12">
			<div class="card">
				<Toast/>
				<!-- Paginada en el servidor: la página, el orden, la búsqueda y los filtros viven en la URL. -->
				<DataTable ref="dt" :value="sales" v-model:selection="selectedSale" selectionMode="single" @rowSelect="onSaleSelected" @rowContextmenu="onSaleContextMenu" contextMenu v-model:contextMenuSelection="contextMenuSale" dataKey="id"
							:lazy="true" :loading="loading" :paginator="true" :rows="listState.pageSize" :first="(listState.page - 1) * listState.pageSize" :totalRecords="totalRecords"
							:sortField="listState.sortField" :sortOrder="listState.sortOrder" @page="onPage($event)" @sort="onSort($event)"
							paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="pageSizes"
							currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} ventas" responsiveLayout="scroll">
					<template #header>
						<div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
							<h5 class="m-0">Ventas</h5>
							<div id="table-header-inputs-container">
								<span id="table-search-input" class="block mt-2 md:mt-0 p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="searchText" placeholder="Buscar por nombre, RUC o número..." @input="onSearchInput" />
								</span>
								<span id="table-buttons-container" class="block mt-2 md:mt-0">
									<Button icon="pi pi-plus" class="p-button-rounded p-button-success mr-2" @click="openNew" />
									<Button icon="pi pi-filter" class="p-button-rounded p-button-secondary mr-2" @click="toggleFilterMenu($event)" />
									<OverlayPanel ref="op2" appendTo="body" :showCloseIcon="false" id="overlay_panel2" style="width: 250px">
										<h5>Buscar por Cliente</h5>
										<div class="grid" style="display: block;">
											<div class="col-12 md:col-12">
												<InputText v-model="this.clientFilter" id="client" type="text" placeholder="Nombre cliente..." style="width: 100%;"/>
											</div>
										</div>
										<h5>Estado de ventas</h5>
										<div class="grid" style="display: block;">
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0">
													<label for="option1" style="width: 100%">Guardada</label>
													<RadioButton id="option1" name="option" value="saved" v-model="saleFilter" />
												</div>
											</div>
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0">
													<label for="option2" style="width: 100%">Archivada</label>
													<RadioButton id="option2" name="option" value="archived" v-model="saleFilter" />
												</div>
											</div>
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0">
													<label for="option3" style="width: 100%">Facturada</label>
													<RadioButton id="option3" name="option" value="receipt" v-model="saleFilter" />
												</div>
											</div>
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0">
													<label for="option4" style="width: 100%">Anuladas</label>
													<RadioButton id="option4" name="option" value="nulled" v-model="saleFilter" />
												</div>
											</div>
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0">
													<label for="option4" style="width: 100%">Todas</label>
													<RadioButton id="option4" name="option" value="all" v-model="saleFilter" />
												</div>
											</div>
										</div>
										<h5>Cobranza</h5>
										<div class="grid" style="display: block;">
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0">
													<label for="option1" style="width: 100%">Cobrada</label>
													<RadioButton id="option1" name="option" value="collected" v-model="collectionFilter" />
												</div>
											</div>
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0">
													<label for="option2" style="width: 100%">Por cobrar</label>
													<RadioButton id="option2" name="option" value="pending" v-model="collectionFilter" />
												</div>
											</div>
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0">
													<label for="option3" style="width: 100%">Vencidas</label>
													<RadioButton id="option3" name="option" value="expired" v-model="collectionFilter" />
												</div>
											</div>
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0">
													<label for="collectionAllOption" style="width: 100%">Todas</label>
													<RadioButton id="collectionAllOption" name="option" :value="null" v-model="collectionFilter" />
												</div>
											</div>
										</div>
										<h5>Rango de fechas</h5>
										<div class="grid" style="display: block;">
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0" style="display: block;">
													<label>Inicio</label>
													<Calendar :showIcon="true" v-model="startFilterDate" dateFormat="dd/mm/yy"></Calendar>
												</div>
											</div>
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0" style="display: block;">
													<label>Fin</label>
													<Calendar :showIcon="true" v-model="endFilterDate" dateFormat="dd/mm/yy"></Calendar>
												</div>
											</div>
										</div>
										<Button class="p-button-success mr-2" style="width: 100%;  margin-top: 15px;" label="Filtrar" @click="filterSales" />
										<Button class="p-button-text p-button-secondary mr-2" style="width: 100%;  margin-top: 5px;" label="Limpiar filtros" @click="clearFilters" />
									</OverlayPanel>
									<!-- Las descargas de ventas son de salesManage: el backend responde 403 sin él (H25). -->
									<Button v-if="$can('salesManage')" icon="pi pi-download" class="p-button-rounded p-button-help mr-2" @click="toggleDownloadMenu($event)" />
									<OverlayPanel ref="op1" appendTo="body" :showCloseIcon="false" id="overlay_panel1" style="width: 250px">
										<h5>Formato de descarga</h5>
										<div class="grid" style="display: block;">
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0">
													<label for="option1" style="width: 100%">Excel por ventas</label>
													<RadioButton id="option1" name="option" value="excel" v-model="formatOption" @click="onRadioButtonChanged('excel')"/>
												</div>
											</div>
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0">
													<label for="excelItemsOption" style="width: 100%">Excel por ítems</label>
													<RadioButton id="excelItemsOption" name="option" value="excel-items" v-model="formatOption" @click="onRadioButtonChanged('excel-items')"/>
												</div>
											</div>
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0">
													<!-- El zip trae el XML autorizado de cada factura vigente; no lleva PDF (H30). -->
													<label for="option2" style="width: 100%">Zip de XML</label>
													<RadioButton id="option2" name="option" value="zip" v-model="formatOption" @click="onRadioButtonChanged('zip')"/>
												</div>
											</div>
										</div>
										<h5>Tipo de ventas</h5>
										<div class="grid" style="display: block;">
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0">
													<label for="receiptOption" style="width: 100%">Solo facturas</label>
													<RadioButton id="receiptOption" name="option" value="receipt" v-model="saleType"/>
												</div>
											</div>
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0">
													<label for="saleOption" style="width: 100%">Solo ventas</label>
													<RadioButton ref="saleRadioButton" id="saleOption" name="option" value="sale" v-model="saleType" :disabled="isOptionDisabled"/>
												</div>
											</div>
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0">
													<label for="nulledOption" style="width: 100%">Solo anuladas</label>
													<RadioButton ref="nulledRadioButton" id="nulledOption" name="option" value="nulled" v-model="saleType" :disabled="isOptionDisabled"/>
												</div>
											</div>
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0">
													<label for="allOption" style="width: 100%">Todas</label>
													<RadioButton ref="allRadioButton" id="allOption" name="option" value="all" v-model="saleType" :disabled="isOptionDisabled"/>
												</div>
											</div>
										</div>
										<h5>Rango de fechas</h5>
										<div class="grid" style="display: block;">
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0" style="display: block;">
													<label>Inicio</label>
													<Calendar :showIcon="true" v-model="initialFilterDate" dateFormat="dd/mm/yy"></Calendar>
												</div>
											</div>
											<div class="col-12 md:col-12">
												<div class="field-radiobutton mb-0" style="display: block;">
													<label>Fin</label>
													<Calendar :showIcon="true" v-model="finalFilterDate" dateFormat="dd/mm/yy"></Calendar>
												</div>
											</div>
										</div>
										<Button v-if="$can('salesManage')" class="p-button-success mr-2" style="width: 100%;  margin-top: 15px;" :loading="this.loadingDownloadButton" label="Descargar" @click="downloadSales" />
									</OverlayPanel>
								</span>
							</div>
							
						</div>
					</template>

                    <Column field="serialNumber" header="Serial" :sortable="true" headerStyle="width:10%; min-width:8rem;">
						<template #body="slotProps">
							<span class="p-column-title">Serie</span>
							{{slotProps.data.serialNumber !== null && slotProps.data.serialNumber !== undefined ? slotProps.data.serialNumber : slotProps.data.id.toString().padStart(9, "0") }}
						</template>
					</Column>
					<Column field="customer.name" header="Cliente" :sortable="true" headerStyle="width:30%; min-width:10rem;">
						<template #body="slotProps">
							<span class="p-column-title">Cliente</span>
							{{slotProps.data.displayName}}
						</template>
					</Column>
					<Column field="total" header="Total" :sortable="true" headerStyle="width:20%; min-width:10rem;">
						<template #body="slotProps">
							<span class="p-column-title">Total</span>
							{{"$"+slotProps.data.total.toFixed(2)}}
						</template>
					</Column>
                    <Column field="createdAtFormatted" header="Fecha" :sortable="true" headerStyle="width:25%; min-width:10rem;">
						<template #body="slotProps">
							<span class="p-column-title">Fecha</span>
							{{slotProps.data.createdAtFormatted}}
						</template>
					</Column>
					<!-- Estado y Cobranza salen de varios campos: no se ordenan en la base. -->
					<Column field="state" header="Estado Documento" headerStyle="width:25%; min-width:10rem;">
						<template #body="slotProps">
							<span :class="'status-badge status-' + slotProps.data.edocStateBadgeColor">{{slotProps.data.edocState}}</span>
						</template>
					</Column>
					<Column field="collectStatusReadable" header="Cobranza" headerStyle="width:25%; min-width:10rem;">
						<template #body="slotProps">
							<span :class="'status-badge status-' + slotProps.data.collectStatusBadgeColor">{{slotProps.data.collectStatusReadable}}</span>
						</template>
					</Column>
				</DataTable>
				<ContextMenu ref="saleContextMenu" :model="saleContextMenuItems" />
			</div>
		</div>
	</div>

</template>

<script>
import { saveDownload } from '../../service/fileDownload';
import httpRequest from '../../service/httpRequest';
import { localISODate, fromLocalISODate } from '../../service/dates';
import Sale from '../../models/sale';

const PAGE_SIZES = [20, 35, 50];
// Las columnas que el backend sabe ordenar (SALE_LIST_ORDERING en dashboard/views.py).
const SORT_FIELDS = ['serialNumber', 'customer.name', 'total', 'createdAtFormatted'];
const SEARCH_DELAY_MS = 350;

export default {
	data() {
		return {
			sales: [],
            sale: new Sale(),
            selectedSale: null,
			saleDialog: false,
			deleteSaleDialog: false,
			deleteSalesDialog: false,
			submitted: false,
			formatOption: 'excel',
			isOptionDisabled: false,
			saleType: 'all',
			pageSizes: PAGE_SIZES,
			totalRecords: 0,
			loading: false,
			// Las respuestas pueden llegar en otro orden (búsqueda con debounce): solo vale la última.
			requestSeq: 0,
			searchText: '',
			searchTimer: null,
			// Borrador del panel de filtros: se aplica a la URL con «Filtrar».
			clientFilter: null,
			saleFilter: 'all',
			collectionFilter: null,
			startFilterDate: null,
			endFilterDate: null,
			initialFilterDate: null,
			finalFilterDate: null,
			loadingDownloadButton: false,
			contextMenuSale: null,
			saleContextMenuItems: [
				{
					label: 'Abrir en nueva pestaña',
					icon: 'pi pi-external-link',
					command: () => this.openSaleInNewTab(this.contextMenuSale),
				},
			],
		}
	},
	computed: {
		// El estado de la lista sale de la URL: sobrevive a volver del formulario y a recargar.
		listState() {
			const query = this.$route.query;
			const positive = (value, fallback) => {
				const number = parseInt(value, 10);
				return Number.isInteger(number) && number > 0 ? number : fallback;
			};
			const pageSize = positive(query.pageSize, PAGE_SIZES[0]);
			const sortField = SORT_FIELDS.includes(query.sortField) ? query.sortField : null;
			return {
				page: positive(query.page, 1),
				pageSize: PAGE_SIZES.includes(pageSize) ? pageSize : PAGE_SIZES[0],
				sortField: sortField,
				sortOrder: sortField ? (query.sortOrder === '-1' ? -1 : 1) : null,
				search: query.search || '',
				client: query.client || '',
				status: query.status || 'all',
				collected: query.collected || null,
				start: query.start || null,
				end: query.end || null,
			};
		},
	},
	watch: {
		'$route.query'() {
			// Al abrir el formulario la ruta cambia antes de desmontar la lista.
			if (this.$route.name !== 'saleCRUD') return;
			this.syncControls();
			this.loadSales();
		},
	},
	created() {
		this.syncControls();
		this.loadSales();
	},
	beforeUnmount() {
		clearTimeout(this.searchTimer);
	},
	methods: {
		openNew() {
			this.$router.push('form');
		},
		hideDialog() {
			this.saleDialog = false;
			this.submitted = false;
		},
		async loadSales() {
			const state = this.listState;
			const seq = ++this.requestSeq;
			this.loading = true;
			const response = await httpRequest.getSalesPage({
				page: state.page,
				pageSize: state.pageSize,
				sortField: state.sortField,
				sortOrder: state.sortOrder,
				search: state.search,
				client: state.client,
				status: state.status === 'all' ? null : state.status,
				collected: state.collected,
				start: state.start,
				end: state.end,
			});
			if (seq !== this.requestSeq) return;
			this.loading = false;
			if (response.status == 200) {
				const data = response.data;
				this.sales = data.items.map(function(item) { return new Sale(item) });
				this.totalRecords = data.totalItems;
				// Una página que ya no existe (p. ej. tras anular) la resuelve el backend en la 1.
				if (data.page !== state.page) { this.updateQuery({page: data.page}) }
			} else {
				this.sales = [];
				this.totalRecords = 0;
				console.log("Error: ", response.status);
			}
		},
		// Escribe el estado en la URL; el watch de `$route.query` vuelve a pedir la página.
		updateQuery(changes) {
			const state = {...this.listState, ...changes};
			const query = {};
			if (state.page > 1) { query.page = String(state.page) }
			if (state.pageSize !== PAGE_SIZES[0]) { query.pageSize = String(state.pageSize) }
			if (state.sortField) {
				query.sortField = state.sortField;
				query.sortOrder = String(state.sortOrder);
			}
			if (state.search) { query.search = state.search }
			if (state.client) { query.client = state.client }
			if (state.status && state.status !== 'all') { query.status = state.status }
			if (state.collected) { query.collected = state.collected }
			if (state.start) { query.start = state.start }
			if (state.end) { query.end = state.end }
			// `replace`: el botón atrás vuelve del formulario a la lista sin recorrer cada página.
			this.$router.replace({query}).then(failure => {
				// Misma URL (p. ej. «Filtrar» sin cambios): no hay navegación, se recarga a mano.
				if (failure) { this.loadSales() }
			});
		},
		// Los controles muestran lo que dice la URL.
		syncControls() {
			const state = this.listState;
			if (this.searchText.trim() !== state.search) { this.searchText = state.search }
			this.clientFilter = state.client || null;
			this.saleFilter = state.status;
			this.collectionFilter = state.collected;
			this.startFilterDate = fromLocalISODate(state.start);
			this.endFilterDate = fromLocalISODate(state.end);
		},
		onPage(event) {
			this.updateQuery({page: event.page + 1, pageSize: event.rows});
		},
		onSort(event) {
			this.updateQuery({sortField: event.sortField, sortOrder: event.sortOrder, page: 1});
		},
		onSearchInput() {
			clearTimeout(this.searchTimer);
			this.searchTimer = setTimeout(() => {
				this.updateQuery({search: this.searchText.trim(), page: 1});
			}, SEARCH_DELAY_MS);
		},
		toggleDownloadMenu(event) {
			this.$refs.op1.toggle(event);
		},
		toggleFilterMenu(event) {
			this.$refs.op2.toggle(event);
		},
		confirmDeleteSelected() {
			this.deleteSalesDialog = true;
		},
		onSaleSelected(event) {
			let sale = event.data;
			this.$router.push('form?id=' + sale.id);
		},
		onSaleContextMenu(event) {
			// Despliega el menú contextual de PrimeVue al hacer click derecho
			// sobre una fila. `contextMenuSelection` ya recibe la venta vía
			// v-model:contextMenuSelection en el DataTable.
			this.$refs.saleContextMenu.show(event.originalEvent);
		},
		openSaleInNewTab(sale) {
			if (!sale) return;
			const route = this.$router.resolve({ name: 'saleForm', query: { id: sale.id } });
			window.open(route.href, '_blank');
		},
		onRadioButtonChanged(format) {
			if (format === "zip") { this.saleType = "receipt" } 
			this.isOptionDisabled = (format === "zip");
		},
		async downloadSales() {
			// Make date verification
			if (this.initialFilterDate !== null && this.finalFilterDate !== null && this.initialFilterDate>this.finalFilterDate) {
				this.$toast.add({severity:'error', summary: 'Fechas incorrectas', detail: 'La fecha inicial no puede ser mayor a la fecha final', life: 3000});
				return;
			}

			// Fechas de calendario locales: el backend corta en la «T» (H64).
			let initialDate = localISODate(this.initialFilterDate)
			let endDate = localISODate(this.finalFilterDate)
			this.loadingDownloadButton = true;
			try {
				const data = await httpRequest.downloadSales(this.formatOption, this.saleType, initialDate, endDate);
				// Si el backend responde JSON en vez de un archivo (p.ej. sin actividad
				// economica seleccionada), saveDownload muestra el motivo y no guarda nada.
				const isExcel = this.formatOption !== "zip";
				const filename = (this.formatOption === "excel-items") ? "ventas_por_items.xlsx"
					: (this.formatOption === "excel") ? "ventas.xlsx" : "facturas.zip";
				const extension = isExcel ? "vnd.ms-excel" : "zip";
				await saveDownload(data, filename, "application/" + extension, this.$toast);
			} finally {
				this.loadingDownloadButton = false;
			}
		},
		filterSales() {
			// Make date verification
			if (this.startFilterDate !== null && this.endFilterDate !== null && this.startFilterDate>this.endFilterDate) {
				this.$toast.add({severity:'error', summary: 'Fechas incorrectas', detail: 'La fecha inicial no puede ser mayor a la fecha final', life: 3000});
				return;
			}

			this.$refs.op2.hide();
			this.updateQuery({
				page: 1,
				client: (this.clientFilter || '').trim(),
				status: this.saleFilter,
				collected: this.collectionFilter,
				// Fechas de calendario locales: el backend corta en la «T» (H64).
				start: localISODate(this.startFilterDate),
				end: localISODate(this.endFilterDate),
			});
		},
		clearFilters() {
			this.$refs.op2.hide();
			this.updateQuery({page: 1, client: '', status: 'all', collected: null, start: null, end: null});
		},
	}
}
</script>

<style scoped lang="scss">
@import '../../assets/demo/badges.scss';

@media screen and (max-width: 769px) {
	#table-header-inputs-container {
		display: block;
	}
	#table-search-input {
		margin: 15px 0px !important;
	}
}
@media screen and (min-width: 769px) {
	#table-header-inputs-container {
		display: flex;
	}
	#table-search-input {
		margin: 0px 15px;
	}
}

.status-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-green {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-red {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-yellow {
        background: #FEEDAF;
        color: #8A5340;
    }

    &.status-orange {
        background: #ffa177;
        color: #da2727;
    }

	&.status-blue {
        background: #B3E5FC;
        color: #23677B;
    }

	&.status-gray {
        background: #d6d8d9;
        color: #464747;
    }
}
</style>
